import { useMemo } from 'react';
import { useCloudId } from '@atlassian/jira-tenant-context-controller';
import { type Source, EXISTING_PROJECT } from '../../constants/source';
import { ExistingProjectClient } from './existing-project';
import { NewProjectClient } from './new-project';

export const useGetCSVImportClient = (source: Source, serviceName?: string) => {
	const cloudId = useCloudId();
	return useMemo(() => {
		if (source === EXISTING_PROJECT) {
			return new ExistingProjectClient(cloudId, serviceName);
		}
		return new NewProjectClient(cloudId, serviceName);
	}, [cloudId, serviceName, source]);
};
